import CookiesPoliceToast from 'components/CookiesPoliceToast'
import { COOKIES_POLICY_KEY } from 'constants/variables'
import Cookies from 'js-cookie'
import React, { useEffect } from 'react'
import { toast, ToastOptions } from 'react-toastify'
import useLocale from './useLocale'

const toastConfig = {
  position: toast.POSITION.BOTTOM_RIGHT,
  autoClose: false,
  toastId: COOKIES_POLICY_KEY,
  className: 'cookie-police-classes__toast',
  bodyClassName: 'cookie-police-classes__body',
  closeOnClick: false,
} as ToastOptions

const useCookiesPolicy: TUseCookiesPolicy = (excludePages = []) => {
  const { pathname } = useLocale()
  useEffect(() => {
    const isExcludePages = excludePages.includes(pathname)
    if (isExcludePages) return
    if (typeof window === 'undefined') return

    const cookiePolicy = Cookies.get(COOKIES_POLICY_KEY)

    if (cookiePolicy) {
      return
    }

    toast(props => <CookiesPoliceToast key={COOKIES_POLICY_KEY} {...props} />, toastConfig)
  }, [excludePages, pathname])
}

type TUseCookiesPolicy = (excludePages: string[]) => void

export default useCookiesPolicy
